<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/B5oGgl/tc-custom/9781504082006.jpg?1726617300488" alt="This image is the cover for the book Hard Latitudes, The Mike Travis Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hard Latitudes, The Mike Travis Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] fast-paced mystery . . . Fans of the prolific Stuart Woods and Randy Wayne White will hope that Birtcher’s engaging series has an equally long life.” —<i>Booklist</i></b><br/>  <br/><b>A Nero Award Finalist</b><br/>  <br/> After twenty years in the LAPD, Mike Travis should be enjoying his retirement in Hawaii. Instead, he’s become a reluctant PI who can’t manage to stay out of trouble—much to the chagrin of his long-suffering girlfriend. <br/>  <br/> This time, the problem is his brother, Valden, head of the family company of Van de Groot Capital. A mover and shaker, he’s in Los Angeles for a political fundraiser at the home of a powerful pharmaceutical titan. But first, he’s being blackmailed. Someone has a compromising video of him and a young woman who is definitely not his wife—and they want three million dollars for it. That’s when he calls Travis. <br/>  <br/> With his longtime connections in Los Angeles—including his former partner on the force—Travis has everything under control, until he doesn’t. Now entangled in a web of murder, finance, and politics, only Travis can unravel a conspiracy international in scope—and unparalleled in evil . . .    <br/>  <br/><b>“Birtcher is a solid, fluent writer; the story unfolds with good-humored ease, and Travis is a personable narrator . . . All of the elements are in place for a tense thriller.” —<i>Kirkus Reviews</i></b><br/>  <br/><b>“Well-executed . . . Readers will hope they don’t have to wait another seven years for the world-weary Travis’s next adventure.” —<i>Publishers Weekly</i></b><br/>  <br/><b>“A thrilling page turner with a very complicated plot that all comes together in the end . . . Highly recommended.” —<i>Detective Mystery Stories</i></b><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Baron Birtcher
      </h2>
      
      <p class="authorDescription body article"><P> Baron Birtcher spent a number of years as a professional musician, and founded an independent record label and management company. His first two novels, <I>Roadhouse Blues</I> and <I>Ruby Tuesday</I>, are <I>Los Angeles Times </I>and Independent Mystery Booksellers Association bestsellers. Birtcher has been nominated for a number of literary awards, including the Nero Award for his novel Hard Latitudes, the Claymore Award for his novel <I>Rain Dogs</I>, and the Left Coast Crime &ldquo;Lefty&rdquo; Award for his novel <I>Angels Fall</I>. He was the 2016 Silver Falchion Award winner for his novel Hard Latitudes and the 2018 Winner of the Killer Nashville Reader&rsquo;s Choice Award for his novel <I>South California Purples.</I></P><P> Birtcher currently divides his time between Portland, Oregon, and Kona, Hawaii. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4dcc8d46